<ng-template #statTemplate>
    @if (modelList.length>0) {
        <div class="grid mt-2">
            <div class="col-7 pl-4 pt-3">
                <ng-container>{{modelList.length+ ' '+('hrPersonnelListViewer.personnelSelected' | translate)}}</ng-container>
            </div>
            <div class="col-5 justify-content-end">
                <p-button  (click)="clearList()"  label="{{'hrPersonnelListViewer.clearList' | translate}}" [text]="true"></p-button>
            </div>
        </div>
    }
</ng-template>

@if (showStatsToTop) {
    <ng-template *ngTemplateOutlet="statTemplate"></ng-template>
}
<p-card>
    <ng-template pTemplate="header">
        <div class="flex col-12">
            <h2 class="w-10 per-list-card-header">{{ headerTitle ? headerTitle : ('hrPersonnelListViewer.perListHeader' | translate) }}</h2>
            <ng-content select="[extToggleLeftSide]"></ng-content>
        </div>
    </ng-template>
    <div class="flex col-12">
        <div class="w-12 mr-4">

            <personnel-picker #perPickerId [selectionMode]="'multiple'" [showSelectedPerCount]="true"
                              (valueEvent)="setPerData($event,true)"
                              [searchable]="true"
                              [queryModel]="personnelQuery"
                              [searchQueryModel]="searchQueryModel"
                              [personnelPicker]="selectedPersonnelPickerData"
                              [(searchResult)]="pickerSearchResult"
            (onSearchPersonnelSelected)="onSearchPersonnelSelected($event)"></personnel-picker>
        </div>
    </div>
    <p-table
        [id]="pageCode + '_per_view_list'"
        [value]="modelList"
        styleClass="p-datatable-striped"
        dataKey="id"
        selectionMode="single"
        (onRowSelect)="rowSelect()"
        [(selection)]="selectedItem"
        scrollable="true"
        scrollHeight="{{ scrollHeight }}"
    >
        <ng-template let-it pTemplate="body">
            <tr [pSelectableRow]="it" [pSelectableRowDisabled]="it.id === selectedItem?.id" [ngClass]="{'p-highlight ':(selectedItemIdObservable | async)===it.id}">
                <td *ngIf="showPerPicture" class="dt-image-col">
                    <img [hidden]="!it.pictureUuid" [src]="getPictureFetchUrlByCmId(it.id)" class="per-image" loading="lazy"
                         alt="…"/>
                    <img [hidden]="it.pictureUuid" [src]="'/assets/images/person.png'" class="per-image" loading="lazy"
                         alt="…"/>
                </td>
                <td class="{{ showPerPicture ? 'dt-detail-col' : 'dt-full-detail-col'}}">
                    <div class="flex align-items-center justify-content-between" style="width: 100%; overflow: hidden;">
                        <div style="flex: 1; min-width: 0;" class="my-2">
                            <div class="per-summary-text">{{ getPerSummary(it) }}</div>
                            <div class="per-detail-text">{{ getPerDetail(it) }}</div>
                        </div>
                        <div class="ml-2 mr-1 flex align-items-center justify-content-center">
                            <i *ngIf="it.id !== selectedItem?.id" class="pi pi-times" style="font-size: 1rem; cursor: pointer;"
                               (click)="rowDelete(it)"></i>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="showPerPicture ? 2 : 1">{{ 'noRecordsFound' | translate }}</td>
            </tr>
        </ng-template>
    </p-table>
</p-card>
@if (!showStatsToTop) {
    <ng-template *ngTemplateOutlet="statTemplate"></ng-template>
}

